import { REQUEST_DELETE_CAMPAIGN, DELETE_CAMPAIGN_SUCCESS, DELETE_CAMPAIGN_ERROR } from './actionTypes';

export const requestDeleteCampaign = () => ({ type: REQUEST_DELETE_CAMPAIGN });

export const deleteCampaignSuccess = campaign => ({ type: DELETE_CAMPAIGN_SUCCESS, payload: campaign });

export const deleteCampaignError = error => ({ type: DELETE_CAMPAIGN_ERROR, payload: error });
